// import React, { useEffect, useState, useRef } from "react";
// import "./SideCardComponent.css";
// import IconSet from "../../../assets/images/IconSet.png";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { getProcessOppurtunitiesAPI } from "../../../operations/services/getProcessOppurtunities";
// import { FiDownload } from "react-icons/fi";
// import DownloadPDF from "./DownloadPDF";

// const SideCardComponent = () => {
//   const navigate = useNavigate();
//   const [topOpportunities, setTopOpportunities] = useState([]);
//   const [downloadAgent, setDownloadAgent] = useState(false);
//   const [downloadProcess, setDownloadProcess] = useState(false);

//   const { Email } = useSelector((state) => state.login?.login?.data?.data?.[0]);

//   const frequentOpportunityDesc = {
//     desc: "Agents sometimes confirm appointments without verifying availability, leading to scheduling conflicts, delays, and patient dissatisfaction. Training is needed to ensure agents consistently check availability beforehand, improving workflow efficiency, reducing errors, and aligning appointments with patient preferences effectively.",
//     "link-to-all-issues": "#",
//   };

//   // Fallback hardcoded opportunities
//   const fallbackOpportunities = [
//     {
//       name: "Improving Language Support and Translation Services",
//       time: "Just now",
//       "icon-url": IconSet,
//     },
//     {
//       name: "Clarification of Delivery Details",
//       time: "59 minutes ago",
//       "icon-url": IconSet,
//     },
//     {
//       name: "Clarity in Communication",
//       time: "12 hours ago",
//       "icon-url": IconSet,
//     },
//     {
//       name: "Efficiency in Handling Calls",
//       time: "Today, 11:59 AM",
//       "icon-url": IconSet,
//     },
//     {
//       name: "Account Management and Navigation",
//       time: "Today, 11:59 AM",
//       "icon-url": IconSet,
//     },
//   ];

//   useEffect(() => {
//     async function fetchOpportunities() {
//       try {
//         const response = await getProcessOppurtunitiesAPI();
//         console.log("Opportunities:", response);

//         if (response && Array.isArray(response) && response.length > 0) {
//           setTopOpportunities(response);
//         }
//       } catch (error) {
//         console.error("Error fetching process opportunities:", error);
//       }
//     }
//     fetchOpportunities();
//   }, []);

//   const handleClick = (e) => {
//     e.preventDefault();
//     navigate("/operationhome/improvementInsight");
//   };

//   const navigateToProcessImprovement = (e) => {
//     e.preventDefault();
//     navigate("/operationhome/processInsight");
//   };

//   return (
//     <div className="secondary-card-component  ">
//       {/* Hardcoded Frequent Opportunity Section */}
//       <div className="card freq-opp" style={{ minHeight: "40%" }}>
//         <div className="freq-opp-head">
//           Most Frequently Occurring Opportunity for Agent
//         </div>
//         <div className="freq-opp-body">
//           <span className="freq-opp-title">
//             {frequentOpportunityDesc.title}
//           </span>
//           <span className="freq-opp-desc">{frequentOpportunityDesc.desc}</span>
//           <div className="see-all-download-row my-1">
//             <a
//               href="/#"
//               className="btn btn-sm freq-opp-button"
//               onClick={handleClick}
//               target="_blank"
//               rel="noopener noreferrer"
//               // style={{ marginBottom: "-15px" }}
//             >
//               See All
//             </a>
//             <FiDownload
//               className="download-icon1"
//               style={{ cursor: "pointer" }}
//               onClick={() => setDownloadAgent(true)}
//             />
//             <span
//               className="download-feature1"
//               onClick={() => setDownloadAgent(true)}
//               style={{ cursor: "pointer" }}
//             >
//               Download PDF
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* Dynamic Process Opportunities Section */}
//       <span className="stat-heading">
//         Top Process Improvement Opportunities:
//       </span>
//       <div className="card card-below">

//         <ul className="opportunity-list m-0">
//           {(topOpportunities.length > 0
//             ? topOpportunities
//             : fallbackOpportunities
//           ).map((opportunity, index) => (
//             <li key={index} style={{ padding: "1px" }}>
//               <img
//                 src={opportunity["icon-url"] || IconSet}
//                 className="opportunity-icon"
//                 alt="Opportunity Icon"
//               />
//               <div className="opportunity-desc">
//                 <span className="opportunity-heading">
//                   {opportunity.heading || opportunity.name}
//                   {opportunity.interactions
//                     ? ` (${opportunity.interactions})`
//                     : ""}
//                 </span>
//                 <span className="opportunity-time">
//                   {opportunity.timeAgo || opportunity.time || "N/A"}
//                 </span>
//               </div>
//             </li>
//           ))}
//         </ul>
//         <div className="see-all-download-row my-1 mb-2 mx-3">
//           <a
//             href="/#"
//             onClick={navigateToProcessImprovement}
//             className="btn btn-sm freq-opp-button"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             See All
//           </a>
//           <FiDownload
//             className="download-icon1"
//             style={{ cursor: "pointer" }}
//             onClick={() => setDownloadProcess(true)}
//           />
//           <span
//             className="download-feature1"
//             style={{ cursor: "pointer" }}
//             onClick={() => setDownloadProcess(true)}
//           >
//             Download PDF
//           </span>
//         </div>
//       </div>

//       {/* Hidden PDF download components */}
//       <DownloadPDF
//         triggerDownload={downloadAgent}
//         setTriggerDownload={setDownloadAgent}
//         cardHeader="Agent"
//         dataAccessor="recommendations"
//       />
//       <DownloadPDF
//         triggerDownload={downloadProcess}
//         setTriggerDownload={setDownloadProcess}
//         cardHeader="Process"
//         dataAccessor="processImprovement"
//       />
//     </div>
//   );
// };

// export default SideCardComponent;
import React, { useEffect, useState } from "react";
import "./SideCardComponent.css";
import IconSet from "../../../assets/images/IconSet.png";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getProcessOppurtunitiesAPI } from "../../../operations/services/getProcessOppurtunities";
import { FiDownload } from "react-icons/fi";
import DownloadPDF from "./DownloadPDF";
import { setRecommendation } from "../../../redux/slices/agentHomeSlice";
import UIConfig from "../../../common/constants/UIConfig";

const SideCardComponent = ({ onDownloadStarted }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [topOpportunities, setTopOpportunities] = useState([]);
  const [downloadAgent, setDownloadAgent] = useState(false);
  const [downloadProcess, setDownloadProcess] = useState(false);

 

  const agentRecommendations = useSelector(
    (state) => state.agentHome.recommendations.agent
  );

  const frequentOpportunityDesc = {
    desc: UIConfig.operationHome.agentImprovementText,
  };

  const fallbackOpportunities = [
    { name: "Improving Language Support and Translation Services", time: "Just now", "icon-url": IconSet },
    { name: "Clarification of Delivery Details", time: "59 minutes ago", "icon-url": IconSet },
    { name: "Clarity in Communication", time: "12 hours ago", "icon-url": IconSet },
    { name: "Efficiency in Handling Calls", time: "Today, 11:59 AM", "icon-url": IconSet },
    { name: "Account Management and Navigation", time: "Today, 11:59 AM", "icon-url": IconSet },
  ];

  useEffect(() => {
    async function fetchOpportunities() {
      if (!agentRecommendations?.length) {
        try {
          const response = await getProcessOppurtunitiesAPI();
          if (response && Array.isArray(response) && response.length > 0) {
            setTopOpportunities(response);
            dispatch(setRecommendation({ agent: response }));
          }
        } catch (error) {
          console.error("Error fetching process opportunities:", error);
        }
      } else {
        setTopOpportunities(agentRecommendations);
      }
    }
    fetchOpportunities();
  }, [dispatch, agentRecommendations]);

  const handleAgentDownload = () => {
    setDownloadAgent(true);
    if (onDownloadStarted) onDownloadStarted("Agent");
  };

  const handleProcessDownload = () => {
    setDownloadProcess(true);
    if (onDownloadStarted) onDownloadStarted("Process");
  };

  const navigateToAgentImprovement = (e) => {
    e.preventDefault();
    navigate("/operationhome/improvementInsight", { state: { from: "operationhome" } });
  };

  const navigateToProcessImprovement = (e) => {
    e.preventDefault();
    navigate("/operationhome/processInsight", { state: { from: "operationhome" } });
  };

   console.log(topOpportunities,"oppurinity")
  return (
    <div className="secondary-card-component">
      {/* CARD 1: AGENT OPPORTUNITIES */}
      <div className="card freq-opp">
        <div className="freq-opp-head">
          Most Frequently Occurring Opportunity for Agent
        </div>

        <div className="freq-opp-body">
          <span className="freq-opp-desc">
            {frequentOpportunityDesc.desc}
          </span>
        </div>

        <div className="see-all-download-row">
          <a href="/#" className="freq-opp-button" onClick={navigateToAgentImprovement}>
            See All
          </a>
          <div className="agent-download-box" onClick={handleAgentDownload}>
            <FiDownload className="download-icon1" />
            <span className="download-feature1">Download PDF</span>
          </div>
        </div>
      </div>

      <span className="stat-heading">
        Top Process Improvement Opportunities:
      </span>

      {/* CARD 2: PROCESS IMPROVEMENT */}
      <div className="card card-below">
        <ul className="opportunity-list">
          {(topOpportunities.length > 0 ? topOpportunities : fallbackOpportunities).map(
            (opportunity, index) => (
              <li key={index}>
                <img
                  src={opportunity["icon-url"] || IconSet}
                  className="opportunity-icon"
                  alt="Icon"
                />
                <div className="opportunity-desc">
                  <span className="opportunity-heading">
                    {opportunity.heading || opportunity.name}
                    {opportunity.interactions ? ` (${opportunity.interactions})` : ""}
                  </span>
                  <span className="opportunity-time">
                    {opportunity.timeAgo || opportunity.time || "N/A"}
                  </span>
                </div>
              </li>
            )
          )}
        </ul>

        <div className="see-all-download-row">
          <a href="/#" onClick={navigateToProcessImprovement} className="freq-opp-button">
            See All
          </a>
          <div className="agent-download-box" onClick={handleProcessDownload}>
            <FiDownload className="download-icon1" />
            <span className="download-feature1">Download PDF</span>
          </div>
        </div>
      </div>

      {/* Hidden Download Components */}
      <DownloadPDF
        triggerDownload={downloadAgent}
        setTriggerDownload={setDownloadAgent}
        cardHeader="Agent"
        dataAccessor="recommendations"
      />
      <DownloadPDF
        triggerDownload={downloadProcess}
        setTriggerDownload={setDownloadProcess}
        cardHeader="Process"
        dataAccessor="processImprovement"
      />
    </div>
  );
};

export default SideCardComponent;